import { Search } from 'lucide-react'
import { EcommercePlatformField } from '@/components/shared/EcommercePlatformField'
import { useLeadSourceOptions } from '@/hooks/useLeadSourceOptions'

interface BdrBankTableFiltersProps {
  search: string
  filterSegmento: string
  filterPlataforma: string
  filterOrigem: string
  onSearchChange: (value: string) => void
  onSegmentoChange: (value: string) => void
  onPlataformaChange: (value: string) => void
  onOrigemChange: (value: string) => void
}

export function BdrBankTableFilters({
  search,
  filterSegmento,
  filterPlataforma,
  filterOrigem,
  onSearchChange,
  onSegmentoChange,
  onPlataformaChange,
  onOrigemChange,
}: BdrBankTableFiltersProps) {
  const { options: origemOptions, loading: origemLoading } = useLeadSourceOptions()
  const selectClass =
    'px-3 py-2 bg-white/[0.03] border border-white/[0.06] rounded-lg text-sm text-text-primary focus:border-accent focus:outline-none'

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[200px]">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted" />
        <input
          type="text"
          placeholder="Buscar empresa, contato..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 bg-white/[0.03] border border-white/[0.06] rounded-lg text-sm text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none transition-colors"
        />
      </div>
      <select value={filterSegmento} onChange={(e) => onSegmentoChange(e.target.value)} className={selectClass}>
        <option value="">Segmento</option>
        <option value="E-commerce">E-commerce</option>
        <option value="SaaS">SaaS</option>
        <option value="Serviços">Serviços</option>
        <option value="Outro">Outro</option>
      </select>
      <EcommercePlatformField
        compact
        value={filterPlataforma}
        onChange={onPlataformaChange}
        selectClassName={selectClass}
        placeholder='Filtrar por nome…'
      />
      <select
        value={filterOrigem}
        onChange={(e) => onOrigemChange(e.target.value)}
        className={selectClass}
        disabled={origemLoading}
      >
        <option value="">{origemLoading ? 'Carregando...' : 'Origem'}</option>
        {origemOptions.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
    </div>
  )
}
